<div id="divBasemapContainer" [class.open]="controlStatus.mostrarMapas">
  <header class="titulo"> Estilos de mapa
    <img class='bt-fechar' src="assets/img/icon_bt-limpar_header.svg" (click)='FecharOpcoesMapas()'>
  </header>
  <div id="divBasemapGallery"></div>
</div>